export default {
  appName: 'Today Rate ',
  appDesc: 'Thank you for using the services provided by Today Rate!',
  authorizationTableiOS01: 'iOS 14.5 and above, allow app tracking',
  authorizationTableiOS02: 'Used to provide personalized advertising',
  authorizationTableAndroid01: 'Allow applications to access the Internet',
  authorizationTableAndroid02: 'Used to obtain exchange rate data from the server',
  authorizationTableAndroid03: 'Allow the application to stay awake',
  authorizationTableAndroid04: 'Used to prevent the application from sleeping',
  authorizationTableAndroid05: 'Allow the application to access coarse location',
  authorizationTableAndroid06: 'Used to display local currency exchange rates based on approximate location',
  companyName: 'Sanhe Zhishi Technology Co., Ltd.',
  contactEmail: "support{'@'}ifyyy.cn",
};
